'use client'

import * as React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { TableRow, TableCell } from '@/components/ui/table'

interface DomainsTableSkeletonProps {
	rows?: number
}

export function DomainsTableSkeleton({ rows = 8 }: DomainsTableSkeletonProps) {
	return (
		<SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
			<>
				{Array.from({ length: rows }, (_, index) => (
					<TableRow key={index}>
						<TableCell className="w-10">
							<Skeleton height={16} width={16} />
						</TableCell>
						<TableCell>
							<Skeleton height={16} width={200} />
						</TableCell>
						<TableCell className="w-32">
							<Skeleton height={20} width={80} borderRadius="0.375rem" />
						</TableCell>
						<TableCell className="w-24">
							<Skeleton height={20} width={60} borderRadius="0.375rem" />
						</TableCell>
						<TableCell className="w-24">
							<Skeleton height={14} width={70} />
						</TableCell>
						<TableCell className="w-10">
							<Skeleton height={32} width={32} borderRadius="0.25rem" />
						</TableCell>
					</TableRow>
				))}
			</>
		</SkeletonTheme>
	)
}

